import { ActionIcon, Box, Group, Icon, Text } from '@inflearn/ds-react-next';
import { faRefresh } from '@inflearn/pro-regular-svg-icons';
import { useTranslation } from 'next-i18next';

type Props = {
  fetchNext: () => void;
};

export default function ReFetchInfinityScroll({ fetchNext }: Props) {
  const { t } = useTranslation();

  return (
    <Group h={140} justify="center">
      <Box display="inline">
        <ActionIcon
          variant="light"
          color="gray"
          size="xl"
          radius="xl"
          m="0 auto"
          aria-label={t('다음 페이지 불러오기')}
          onClick={fetchNext}
        >
          <Icon icon={faRefresh} color="gray.6" />
        </ActionIcon>
        <Text mt={4} size="sm" c="gray.6" fw={500}>
          {t('다시 불러오기')}
        </Text>
      </Box>
    </Group>
  );
}
